<template>
  <svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.2092 5.79071C11.634 4.2156 9.08028 4.2156 7.50517 5.79071L7.03376 6.26212C6.7604 6.53548 6.7604 6.9787 7.03376 7.25207C7.30713 7.52543 7.75034 7.52543 8.02371 7.25206L8.49512 6.78066C9.5235 5.75228 11.1908 5.75228 12.2192 6.78066C13.2476 7.80904 13.2476 9.47638 12.2192 10.5048L11.0951 11.6289C10.1668 12.5571 8.66186 12.5571 7.73362 11.6289L7.55231 11.4476C7.27894 11.1742 6.83572 11.1742 6.56236 11.4476C6.28899 11.7209 6.28899 12.1641 6.56236 12.4375L6.74367 12.6188C8.21865 14.0938 10.6101 14.0938 12.085 12.6188L13.2092 11.4947C14.7843 9.91959 14.7843 7.36583 13.2092 5.79071ZM4.90527 10.3706C5.83351 9.44235 7.3385 9.44234 8.26674 10.3706L8.44805 10.5519C8.72142 10.8253 9.16464 10.8253 9.438 10.5519C9.71137 10.2785 9.71137 9.83532 9.438 9.56195L9.25669 9.38064C7.78171 7.90566 5.3903 7.90566 3.91532 9.38064L2.7912 10.5048C1.21608 12.0799 1.21608 14.6336 2.7912 16.2088C4.36631 17.7839 6.92008 17.7839 8.49519 16.2088L8.9666 15.7373C9.23996 15.464 9.23997 15.0208 8.9666 14.7474C8.69323 14.474 8.25002 14.474 7.97665 14.7474L7.50524 15.2188C6.47686 16.2472 4.80953 16.2472 3.78115 15.2188C2.75277 14.1904 2.75277 12.5231 3.78115 11.4947L4.90527 10.3706Z" 
      :fill="active ? '#1677FF' : '#262626'" fill-opacity="0.88"/>
  </svg>
</template>

<script>
export default {
  props: {
    active: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
};
</script>
